// extracted by mini-css-extract-plugin
export var animationWrapper = "e_X_cz";
export var contentWrapper = "e_X_cB";
export var headingWrapper = "e_X_cC";
export var screenTablet = "768px";
export var sectionContainer = "e_X_9";